const Twitter = name => {
  return `https://twitter.com/@${name}/`;
};

const YouTube = channel => {
  return `https://www.youtube.com/channel/${channel}`;
};

const Twitch = name => {
  return `https://www.twitch.tv/${name}`;
};

const Patreon = name => {
  return `https://www.patreon.com/${name}`;
};

const Instagram = name => {
  return `https://www.instagram.com/${name}`;
};

const Discord = ID => {
  return `https://www.discord.gg/${ID}`;
};

module.exports = {
  Twitter,
  YouTube,
  Patreon,
  Instagram,
  Twitch,
  Discord
};
